/** Las pestañas de la pantalla bajo «Dónde y cuándo se espera», por posición en el `TabView`. */
export const URGENCY_TAB = {
  evolution: 0,
  hourly: 1,
  priorities: 2,
  grouped: 3,
} as const
